import { createContext, useContext } from "react";

import type {
  ParameterTimeSeriesConfiguration,
  ParametersLocation,
  ParametersObservedParameter,
} from "@/lib/api";

import type { MarkerSeriesAggregateStatus } from "./marker-display-state";

export type StationMarkersInteraction = {
  selectedLocationId: string | undefined;
  onSelectLocation: (location: ParametersLocation) => void;
  onClearSelection: () => void;
  timeSeriesConfigurations: ParameterTimeSeriesConfiguration[];
  configuredParameters: ParametersObservedParameter[];
  onAggregateStatusChange?: (status: MarkerSeriesAggregateStatus) => void;
};

const StationMarkersInteractionContext = createContext<StationMarkersInteraction | null>(
  null,
);

export function StationMarkersInteractionProvider({
  value,
  children,
}: {
  value: StationMarkersInteraction;
  children: React.ReactNode;
}) {
  return (
    <StationMarkersInteractionContext.Provider value={value}>
      {children}
    </StationMarkersInteractionContext.Provider>
  );
}

export function useStationMarkersInteraction(): StationMarkersInteraction {
  const context = useContext(StationMarkersInteractionContext);
  if (!context) {
    throw new Error(
      "useStationMarkersInteraction must be used within StationMarkersInteractionProvider",
    );
  }
  return context;
}
